import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row d-flex align-items-stretch" }
const _hoisted_2 = { class: "blog-text p-3 w-100" }
const _hoisted_3 = { class: "my-2 text-center port-img-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "port-info-content" }
const _hoisted_6 = { class: "m-0 p-0 th_data" }
const _hoisted_7 = { class: "m-0 p-0 en_data" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 4,
  class: "small my-3 th_data"
}
const _hoisted_13 = {
  key: 5,
  class: "small my-3 en_data"
}
const _hoisted_14 = {
  key: 6,
  class: "small my-3 th_data"
}
const _hoisted_15 = {
  key: 7,
  class: "small my-3 en_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portdatas, (portdata) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-md-4 col-12 my-3 d-flex",
        key: portdata._id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.getImage(portdata.images),
              onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImgError && _ctx.handleImgError(...args))),
              class: "img-fluid img-thumbnail port-img",
              alt: "Portfolio Image"
            }, null, 40, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(portdata.name ? portdata.name.th : ''), 1),
            _createElementVNode("h6", _hoisted_7, _toDisplayString(portdata.name ? portdata.name.en : ''), 1),
            (portdata.link && portdata.link.th != '')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "small my-3 th_data",
                  innerHTML: portdata.link.th
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            (portdata.link && portdata.link.en != '')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "small my-3 en_data",
                  innerHTML: portdata.link.en
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (portdata.content && portdata.content.th != '')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "small my-3 th_data",
                  innerHTML: 'หน้าที่/ความรับผิดชอบ:<br />'+portdata.content.th
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true),
            (portdata.content && portdata.content.en != '')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "small my-3 en_data",
                  innerHTML: 'Responsibility:<br />'+portdata.content.en
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true),
            (portdata.technology && portdata.technology.th != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Tech: " + _toDisplayString(portdata.technology.th), 1))
              : _createCommentVNode("", true),
            (portdata.technology && portdata.technology.en != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Tech: " + _toDisplayString(portdata.technology.en), 1))
              : _createCommentVNode("", true),
            (portdata.api && portdata.api.th != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "API ภายนอก: " + _toDisplayString(portdata.api.th), 1))
              : _createCommentVNode("", true),
            (portdata.api && portdata.api.en != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "External API: " + _toDisplayString(portdata.api.en), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}